<!-- Hero Section with Search -->
<section class="hero">
  <div class="container">
    <h1 class="hero__title">{{ 'companies.title' | transloco }}</h1>
    <p class="hero__description">{{ 'companies.subtitle' | transloco }}</p>

    <!-- Search Box -->
    <div class="filter-box">
      <div class="filter-box__row">
        <div class="filter-box__input filter-box__input--search">
          <i class="fas fa-search"></i>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="searchKeyword"
            [placeholder]="'companies.searchPlaceholder' | transloco"
            (keyup.enter)="onSearch()"
          />
          <button
            *ngIf="searchKeyword"
            class="clear-btn"
            (click)="searchKeyword = ''; onSearch()"
            type="button"
            aria-label="Clear search"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        <button type="button" class="filter-box__button filter-box__button--inline" (click)="onSearch()">
          <i class="fas fa-search"></i>
          {{ 'button.search' | transloco }}
        </button>
      </div>

      <div class="filter-box__actions">
        <div class="results-count" *ngIf="!isLoading">
          <span>{{ totalCompanies }} {{ 'companies.companiesFound' | transloco }}</span>
        </div>
        <div class="main-actions">
          <button
            type="button"
            class="filter-box__button filter-box__button--secondary"
            (click)="searchKeyword = ''; onSearch()"
            *ngIf="searchKeyword"
          >
            <i class="fas fa-redo"></i>
            {{ 'filters.clearAll' | transloco }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Companies Content Section -->
<section class="companies-content">
  <div class="container">
    <app-loading *ngIf="isLoading"></app-loading>

    <div class="companies-list" *ngIf="!isLoading && companies.length > 0">
      <app-company-card
        *ngFor="let company of companies"
        [company]="company"
      ></app-company-card>
    </div>

    <div class="companies-empty" *ngIf="!isLoading && companies.length === 0">
      <i class="fas fa-building"></i>
      <h3>{{ 'companies.noResults' | transloco }}</h3>
      <p>{{ 'companies.noResultsDescription' | transloco }}</p>
    </div>

    <nav class="companies-pagination" *ngIf="!isLoading && totalPages > 0">
      <button
        class="pagination-btn"
        [disabled]="currentPage === 0"
        (click)="onPageChange(currentPage - 1)"
      >
        <i class="fas fa-chevron-left"></i>
        {{ 'pagination.previous' | transloco }}
      </button>

      <div class="pagination-pages">
        <ng-container *ngFor="let page of pages">
          <span *ngIf="page === -1" class="pagination-ellipsis">...</span>
          <button
            *ngIf="page !== -1"
            class="pagination-page"
            [class.active]="page === currentPage"
            (click)="onPageChange(page)"
          >
            {{ page + 1 }}
          </button>
        </ng-container>
      </div>

      <button
        class="pagination-btn"
        [disabled]="currentPage === totalPages - 1"
        (click)="onPageChange(currentPage + 1)"
      >
        {{ 'pagination.next' | transloco }}
        <i class="fas fa-chevron-right"></i>
      </button>
    </nav>
  </div>
</section>
